import { render, staticRenderFns } from "./ResumeItem.vue?vue&type=template&id=5781ba70&scoped=true&"
import script from "./ResumeItem.vue?vue&type=script&lang=js&"
export * from "./ResumeItem.vue?vue&type=script&lang=js&"
import style0 from "./ResumeItem.vue?vue&type=style&index=0&id=5781ba70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5781ba70",
  null
  
)

export default component.exports